import { render, staticRenderFns } from "./StaffGeneralCompanyInstruction.vue?vue&type=template&id=2fa5fca2&scoped=true&"
import script from "./StaffGeneralCompanyInstruction.vue?vue&type=script&lang=js&"
export * from "./StaffGeneralCompanyInstruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa5fca2",
  null
  
)

export default component.exports